<template>
    <div>
        <div class="modal-container has-text-centered">
           
            <div id="login" class="top40 bottom10">
              <span class="is-size-3 isAvenir has-text-coolGreen right10">
                <img class="top12" src="@/assets/img/Miimu logo.png" width="140" />
              </span>
            </div> 
            <div v-show="!$root.app.inExt" id="xButt" class="delete is-pulled-right top10" @click="doClose"></div>


            <div class="modal-body">
                <div>Login</div>
                <form class="top40">
                    <div class="field" >
                       
                        <input  type="text" placeholder="Email" class="input azTextInput" name="Email" v-validate="'required|email'" v-model="email" />

                    </div>
                    <div class="field posRelative" >
                        <input id="pwd" class="input azTextInput" :type="pType" placeholder="Password" name="Password" v-validate="'required'" v-model="password"/>
                        <div class="eye top-24"><i class="fa fa-eye" @click="togglePtype"></i></div>
                    </div>

                    <div v-if="showErrMsg" class="bottom10">
                        <span class="has-text-danger">{{errMsg}}</span>
                    </div>

                    <div class="is-size-65 is-dark handCursor has-text-left" @click.prevent="forgot">Forgot Password?</div>

                    <div class="top20">
                        <button id="goButton" class="button wideButton is-coolGreen top20" type="submit" @click.prevent="authenticate">GO</button>
                        
                    </div>
                </form>
               <!--  <div class="has-text-centered has-text-grey-light">
                    ___________________________________
                </div> -->

                <div class="level top20">
                    <div class="is-inline">Don't have an account? </div>
                    <div class="is-inline-block underlined handCursor" v-on:click="doRegister">Register</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { off } from "process";

var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
export default {
  props: { message: String },
  data: function() {
    return {
      email: "",
      password: "",
      showErrMsg: true,
      errMsg: "",
      pType: 'password',
      az: az,
    };
  },
  mounted: function() {
    if(this.$root.app.isAuth){
      this.$router.push('/')
      this.$root.app.showModalOK({message: 'You are already signed in.'})
    }
  },
  methods: {
    doLogin: function() {
      // TODO remove this function after Cognito fully implemented
      /* this.$root.isAuth = true;
      if (this.$root.app.goAfterLogin != "") {
        this.$router.push(this.$root.app.goAfterLogin);
        this.$root.app.goAfterLogin = "";
      }

      this.$emit("close"); */
      //
    },
    doRegister: function() {
     //TODO: once non subs products are being sold, second part of conditional must check that at least 1 product in cart is a subs.
     /*  if(this.$root.app.useGetStartedFlow || this.$root.app.cartContents.length > 0){
        this.$router.push("/register");
        this.$emit("close");
        return
      }
      this.$router.push({name: 'picksubs', params: {showMsg: true}});
      this.$emit("close"); */
      if(this.$root.app.inApp){
        this.$router.push('/register');
      } else {
        this.$router.push('/pricing');
      }
      
      this.$emit("close"); 
    },
    doClose: function() {
      this.$root.app.goAfterLogin = "";
      this.$emit("close");
    },
    forgot: function() {
      this.$emit("close");
      this.$router.push("/forgot");
    },
    togglePtype: function(){
        if(this.pType == 'password')
            this.pType = 'text'
        else
            this.pType = 'password'
    },
    authenticate: function() {
      var self = this;
      if(this.$root.app.inApp){
       
        this.password = document.getElementById('pwd').value

      }
      
    
      this.$validator.validateAll().then(res => {
        if (res) {
          sendAuth();
        } else {
          self.errMsg = "Please provide a full email address and your password.";
          self.showErrMsg = true;
        }
      });

      function sendAuth() {
        az.addRemSpinner(true, "id", "goButton");

        self.errMsg = "";
        self.showErrMsg = false;

        self.$root.app.azCognito.authenticate(
          self.email.toLowerCase(),
          self.password,
          authenticateCallBack
        );

        function authenticateCallBack(result, obj) {
          az.addRemSpinner(false, "id", "goButton");
          
          //// INSERT APP HOOK to copy local storage
         
          if(self.$root.app.inApp && self.$root.app.goAfterLogin.substring(0, 10) != '/extension')
            window.webkit.messageHandlers.myMessageName.postMessage("writeLocal")
          else if(self.$root.app.inApp && self.$root.app.goAfterLogin.substring(0, 10) == '/extension')
            window.webkit.messageHandlers.myMessageName.postMessage("writeLocalFromLogin")

          if (result == "error") {
            if (
              obj.message == "Incorrect username or password." ||
              obj.message == "User does not exist."
            ) {
              self.errMsg = "Incorrect email or password.";
              self.showErrMsg = true;
            } else if (obj.message == "Password attempts exceeded") {
              self.errMsg =
                "Password attempts limit exceeded, please try again later.";
              self.showErrMsg = true;
            } else if (obj.code == "UserNotConfirmedException") {
              self.$router.push("/unverified");
              self.$root.app.userAttrs.email = self.email;
              self.$emit("close");
            }
            return;
          } else if (result == "changePwd") {
            self.$emit("close");
            self.$router.push("/completereg");
            return;
          }

          self.$root.app.doneFederating = false;
          self.$emit("close");
          if(self.message == 'reloadPage')
             location.reload()
          // if contidional is true, means email is not verified:
          if (self.$root.app.doAuthenticated(obj, true) == true) {
            self.$root.app.azCognito.logOutUser(null);
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.joinButt{
  position: absolute;
  right: 10px;
  bottom: 15px;
}

#login{
  font-size: 1.5rem;
  margin-left: 10px
}

.delete{
  position: absolute;
  top: 0;
  right: 3px
}

 #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
  }

.modal-container {
  width: 350px;
  padding: 1.5rem
}
.delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
</style>
